import { Link } from "react-router-dom";
import { MapPin, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";
import { fmt } from "@/lib/format";

export default function PropertyCard({ p, index = 0 }) {
  const pct = p.total_bricks > 0 ? (p.sold_bricks / p.total_bricks) * 100 : 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
    >
      <Link
        to={`/properties/${p.id}`}
        data-testid={`property-card-${p.id}`}
        className="block bp-card rounded-2xl overflow-hidden group"
      >
        <div className="aspect-[16/10] relative overflow-hidden">
          <img
            src={p.image_url}
            alt={p.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050914] via-transparent to-transparent" />
          <div className="absolute top-3 right-3 px-2 py-1 rounded-full bg-[#050914]/80 border border-[#D4AF37]/30 text-[10px] font-mono tracking-wider text-[#D4AF37]">
            {p.roi_percentage?.toFixed(1)}% ROI
          </div>
        </div>
        <div className="p-5">
          <div className="flex items-center gap-1.5 text-gray-400 text-xs mb-1">
            <MapPin className="w-3 h-3" /> {p.location}
          </div>
          <h3 className="font-heading text-xl text-white font-medium tracking-tight">
            {p.name}
          </h3>
          <div className="mt-4">
            <div className="flex items-baseline justify-between text-xs mb-2">
              <span className="overline">Bricks sold</span>
              <span className="font-mono text-white">
                {p.sold_bricks}/{p.total_bricks}
              </span>
            </div>
            <div className="h-2 rounded-full bg-white/5 border border-white/10 overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-[#D4AF37] to-[#FDE047]"
                style={{ width: `${pct}%` }}
              />
            </div>
          </div>
          <div className="mt-4 flex items-center justify-between pt-4 border-t border-white/5">
            <div>
              <div className="overline">Per brick</div>
              <div className="font-heading text-[#D4AF37] text-xl">
                {fmt(p.price_per_brick)}
              </div>
            </div>
            <div className="flex items-center gap-1 text-xs text-green-400">
              <TrendingUp className="w-3 h-3" /> {p.rental_yield?.toFixed(1)}% yield
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
